/**
 *
 * IBM Confidential
 *
 * (C) Copyright IBM Corp. 2021, 2023
 *
 * The source code for this program is not published or otherwise
 * divested of its trade secrets, irrespective of what has been
 * deposited with the U. S. Copyright Office
 *
 * US Government Users Restricted Rights - Use, duplication or
 * disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 *
 **/

import { PasswordInput, TextInput } from 'carbon-components-react';
import React, { useState } from 'react';
import { useFormContext } from 'react-hook-form';
import { FormattedMessage, useIntl } from 'react-intl';

import { useFormHelpers } from '../../../hooks/useFormHelpers';
import { ChannelContentProps } from '../../../util/types';
import { ControlledCheckbox } from '../../common/ControlledCheckbox';
import { FIELDS } from '../schema';
import { AdvancedOptions as messages } from './messages';

export const SipAuthentication = ({ readOnly }: ChannelContentProps) => {
  const { formatMessage: t } = useIntl();

  const formMethods = useFormContext();
  const { getFieldValue, registerInputField } = useFormHelpers(formMethods);
  const { trigger } = formMethods;

  const sipAuthUsernameChangeState = useState<boolean>(false);
  const sipAuthPasswordChangeState = useState<boolean>(false);

  // SIP Auth Enabled
  const sipAuthEnabled = getFieldValue(FIELDS.SIP.AUTHENTICATION);

  return (
    <>
      <h4>
        <FormattedMessage {...messages.subtitleTwo} />
      </h4>
      <div className="TabContent__field-container">
        <ControlledCheckbox
          readOnly={readOnly}
          field={FIELDS.SIP.SECURE_TRUNKING}
          labelText={t(messages.forceSecureTrunking)}
        />
        <ControlledCheckbox
          readOnly={readOnly}
          field={FIELDS.SIP.AUTHENTICATION}
          labelText={t(messages.enableSipAuth)}
          onChange={async () => await trigger()}
        />
        {sipAuthEnabled && (
          <div className="Phone__AdvancedOptions-checkbox">
            <div className="Phone__AdvancedOptions-checkbox-first">
              <TextInput
                {...registerInputField({
                  field: FIELDS.SIP.USERNAME,
                  isQuickSetup: false,
                  labelText: messages.usernameLabel,
                  placeholderText: messages.usernamePlaceholder,
                  changeState: sipAuthUsernameChangeState,
                  readOnly: readOnly
                })}
              />
            </div>
            <PasswordInput
              {...registerInputField({
                field: FIELDS.SIP.PASSWORD,
                isPasswordField: true,
                isQuickSetup: false,
                labelText: messages.passwordLabel,
                placeholderText: messages.passwordPlaceholder,
                changeState: sipAuthPasswordChangeState,
                readOnly: readOnly
              })}
            />
          </div>
        )}
      </div>
    </>
  );
};
